export const DEFAULT_IMAGE_URL = 'https://www.novatechstore.com.ar/pub/media/catalog/product/i/3/i3_1_1.jpg';
